// @flow

import * as React from 'react';

import { Button, Footer, Page, PageContainer, Panel, genRuby } from '@sonyged/ext-proc';
import css from '@styled-system/css';
import styled from 'styled-components';

import { Pizza } from '../../pizza/fields/domain/pizza';
import { Stars } from './Stars';
import PizzaContainer from '../../pizza/fields/PizzaContainer';
import PizzaStoreLogo from '../../../../assets/images/pages/top/img_theme_pizza@3x.png';

type Props = {
  scores: number[],
  stars: number[],
  pizzas: Pizza[],
  roundIndex: number,
  onNext: () => void,
  showResult: number => void,
};

class PizzaAdvanceStatsView extends React.Component<Props> {
  componentDidMount() {
    const currentCard = document.getElementById('current-day');
    if (currentCard) currentCard.scrollIntoView(false);
  }

  render() {
    const { pizzas, scores, stars, roundIndex, showResult } = this.props;
    let totalScore = scores.reduce((x, y) => x + y, 0);

    return (
      <div className="pizza-inner-view pizza-stats-view tertiary100-bg-color">
        <Page.normal>
          <PageContainer.normal>
            <div className="header">
              <div className="left" />

              <div className="center">
                <img src={PizzaStoreLogo} />
              </div>

              <div className="right">
                <div>
                  <div>
                    <span className="proc-pizzaTotal-title gray100-color">{genRuby('合計')}</span>
                  </div>
                  <div>
                    <span className="proc-pizzaTotal-amount gray100-color">{totalScore || 0}</span>{' '}
                    <span className="proc-pizzaTotal-yen proc-small-font gray100-color">円</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="content" id="proc-card-list">
              {[0, 1, 2, 3].map(round => {
                if (round < roundIndex) {
                  return (
                    <PizzaCardPanel
                      key={round}
                      className="proc-panel--dim proc-card proc-card proc-pizzaCard proc-hover proc-button-se"
                      onClick={() => showResult(round)}
                      style={{ paddingBottom: 6 }}
                    >
                      <div className="left dim">
                        <span className="proc-pizzaCard-title">{round + 1 + '日目の結果'}</span>
                        <PizzaCardRating>
                          <div className="proc-pizzaCard--rating">
                            <Stars stars={stars[round]} />
                          </div>
                        </PizzaCardRating>
                      </div>
                      <div className="right">
                        <span>
                          <span className="proc-pizzaCard-amount gray100-color">{scores[round]}</span>{' '}
                          <span className="proc-pizzaCard-yen gray100-color">円</span>
                        </span>
                        <div className="proc-pizzaCard--ingredient dim">
                          <PizzaViewport className="pizza-viewport">
                            <div className="pizza-viewport-inner">
                              <PizzaContainer pizza={pizzas[round]} />
                            </div>
                          </PizzaViewport>
                        </div>
                      </div>
                    </PizzaCardPanel>
                  );
                }

                if (round === roundIndex) {
                  return (
                    <React.Fragment key={round}>
                      <div id="current-day" style={{ height: 0 }} />
                      <PizzaCardPanel
                        className="proc-card proc-pizzaCard proc-hover proc-button-se"
                        onClick={this.props.onNext}
                      >
                        <div className="left">
                          <span className="proc-pizzaCard-title">{round + 1 + '日目'}</span>
                          <div />
                        </div>
                        <div className="right" />
                      </PizzaCardPanel>
                    </React.Fragment>
                  );
                }

                if (round > roundIndex) {
                  return (
                    <PizzaCardPanel key={round} className="proc-card proc-pizzaCard disabled">
                      <div className="left">
                        <span className="proc-pizzaCard-title">{round + 1 + '日目'}</span>
                      </div>
                    </PizzaCardPanel>
                  );
                }
              })}
            </div>
          </PageContainer.normal>
        </Page.normal>
        <Footer.normal className="white-bg-color">
          <Button.attention onClick={this.props.onNext}>つぎへ</Button.attention>
        </Footer.normal>
      </div>
    );
  }
}

export default PizzaAdvanceStatsView;

const PizzaCardPanel = styled(Panel.horizontal)(
  css({
    height: [87, 87, 128],
  })
);

const PizzaViewport = styled('div')(
  css({
    width: 72,
    height: 40,
    ml: 'auto',
    mt: '4px',
    '.pizza-image.pizza-container': {
      top: 0,
      width: '100%',
      height: '100%',
      left: '6px',
    },
  })
);

const PizzaCardRating = styled('div')(
  css({
    mt: '6px',
  })
);
